module.exports = __webpack_public_path__ + "img/myanmar.2b9692cc.svg";